import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";

// El <main> de App tiene 20px de padding: las secciones a ancho completo lo anulan
export const FullBleed = styled(Box)({
  marginLeft: "-20px",
  marginRight: "-20px",
});

export const Section = styled(FullBleed)(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up("md")]: {
    paddingTop: theme.spacing(14),
    paddingBottom: theme.spacing(14),
  },
}));

// Imagen con zoom lento al pasar el mouse
export const ZoomImage = styled(Box)({
  position: "relative",
  overflow: "hidden",
  borderRadius: 24,
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    transition: "transform 1.2s cubic-bezier(.2,.7,.2,1)",
  },
  "&:hover img": {
    transform: "scale(1.06)",
  },
});

export const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(32px); }
  to { opacity: 1; transform: none; }
`;

// Encabezado de sección: overline + título (+ bajada opcional)
export const SectionTitle = ({ overline, title, children, light, align = "left", sx }) => (
  <Box sx={{ textAlign: align, mb: { xs: 5, md: 7 }, ...sx }}>
    <Typography
      variant="overline"
      sx={{ color: light ? "primary.light" : "primary.main" }}
    >
      {overline}
    </Typography>
    <Typography variant="h2" sx={{ mt: 1, color: light ? "white" : "text.primary" }}>
      {title}
    </Typography>
    {children && (
      <Typography
        sx={{
          mt: 2,
          fontSize: "1.1rem",
          maxWidth: 640,
          mx: align === "center" ? "auto" : 0,
          color: light ? "rgba(255,255,255,0.85)" : "text.secondary",
        }}
      >
        {children}
      </Typography>
    )}
  </Box>
);

// Hero con foto para las páginas internas
export const PageHero = ({ image, imagePosition = "center", overline, title, children }) => (
  <FullBleed
    sx={{
      position: "relative",
      mt: "-20px",
      minHeight: { xs: 380, md: "55vh" },
      display: "flex",
      alignItems: "flex-end",
      backgroundImage: `url("${image}")`,
      backgroundSize: "cover",
      backgroundPosition: imagePosition,
      color: "white",
      "&::before": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(to top, rgba(0,30,15,0.8) 0%, rgba(0,0,0,0.25) 60%, rgba(0,0,0,0.15) 100%)",
      },
    }}
  >
    <Container
      sx={{
        position: "relative",
        pb: { xs: 5, md: 8 },
        animation: `${fadeUp} 1s cubic-bezier(.2,.7,.2,1) both`,
        "@media (prefers-reduced-motion: reduce)": { animation: "none" },
      }}
    >
      <Typography variant="overline" sx={{ color: "primary.light" }}>
        {overline}
      </Typography>
      <Typography variant="h1" sx={{ color: "white", mt: 1 }}>
        {title}
      </Typography>
      {children && (
        <Typography
          sx={{
            color: "rgba(255,255,255,0.9)",
            fontSize: { xs: "1.05rem", md: "1.25rem" },
            maxWidth: 640,
            mt: 2,
          }}
        >
          {children}
        </Typography>
      )}
    </Container>
  </FullBleed>
);
